import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentindaund() {



    const cardData =
    {
        keyword: 'Urbania On Rent in Daund',
        heading: 'Urbania on rent in pune: Urbania On Rent in Daund',
        headingDescription: 'Urbania On Rent in Pune offers reliable and comfortable Urbania On Rent in Daund for corporate groups, families, tourists, and event travelers planning trips to and from Daund. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for long-distance travel, weekend getaways, corporate outings, airport transfers, weddings, sightseeing, and outstation journeys from Pune to Daund. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe and stress-free travel experience. Backed by 24/7 booking support, punctual service, and transparent pricing, Urbania On Rent in Pune stands out as the trusted choice for premium Urbania hire in Daund.',

        top: 'Top Places to Visit in Daund with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Bhima River Ghat",
    "description": "The Bhima River Ghat in Daund is one of the most peaceful and culturally important spots in the town. The river plays a vital role in local agriculture and daily life. Early mornings and evenings are especially serene, with devotees performing rituals, locals taking walks, and fishermen at work. During festivals, the ghat becomes lively with religious activities, making it a calm yet spiritually enriching place to visit."
  },
  {
    "title": "Shree Siddheshwar Temple",
    "description": "Shree Siddheshwar Temple is a prominent local temple in Daund dedicated to Lord Shiva. The temple is known for its simple architecture, spiritual ambiance, and strong devotion among locals. Mahashivratri is celebrated with great enthusiasm, drawing devotees from nearby villages. It is a peaceful place for prayer and reflection."
  },
  {
    "title": "Daund Railway Junction",
    "description": "Daund Railway Junction is one of the most important railway hubs in Maharashtra, connecting major routes toward Pune, Solapur, Hyderabad, and southern India. The junction holds historical importance in Indian Railways and reflects the town’s strategic significance. Observing the constant movement of trains gives visitors a glimpse into Daund’s role in regional connectivity."
  },
  {
    "title": "Shree Vitthal-Rukmini Temple",
    "description": "Inspired by the Pandharpur Vitthal tradition, the Vitthal-Rukmini Temple in Daund is a major spiritual center for devotees. The temple sees special celebrations during Ashadhi and Kartiki Ekadashi, with bhajans and palkhi-style devotion. The atmosphere is deeply spiritual, offering a strong connection to Maharashtra’s devotional culture."
  },
  {
    "title": "Kumbhargaon Dam (Near Daund)",
    "description": "Located close to Daund, Kumbhargaon Dam is a quiet and scenic spot surrounded by open landscapes and farmland. It is mainly used for irrigation but also attracts locals for evening relaxation, photography, and peaceful outings. During monsoon, the area becomes lush and green, offering a refreshing natural escape."
  },
  {
    "title": "Agricultural Market (Daund APMC)",
    "description": "The Daund APMC market is one of the busiest agricultural trading centers in the region. Farmers from surrounding villages bring crops like sugarcane, grains, vegetables, and fruits for trade. Visiting the market provides insight into rural Maharashtra’s economy, farming lifestyle, and vibrant local interactions."
  },
  {
    "title": "Local Sugar Factories Area",
    "description": "Daund is surrounded by sugarcane farms and sugar factories that form the backbone of the local economy. These areas reflect the agricultural strength of the region. During harvesting season, the landscape is filled with green fields and active transport, showcasing the hardworking rural culture of Daund."
  },
  {
    "title": "Shree Hanuman Mandir",
    "description": "The Hanuman Mandir in Daund is a popular place of worship, especially on Tuesdays and Saturdays. Devotees visit to seek strength, protection, and blessings. The temple has a calm environment and is deeply rooted in the faith of the local community, making it an important spiritual landmark."
  },
  {
    "title": "Nearby Rural Villages Experience",
    "description": "The villages surrounding Daund offer an authentic rural Maharashtra experience. Visitors can witness traditional farming practices, bullock carts, village temples, and simple lifestyles. The warm hospitality, open fields, and slow-paced life provide a refreshing contrast to urban environments."
  },
  {
    "title": "Canal Road Walks",
    "description": "The irrigation canals around Daund are popular for morning and evening walks. These canal roads offer open views of farmland, flowing water, and fresh air. Locals often gather here for exercise and relaxation. The peaceful surroundings make it a simple yet enjoyable nature experience."
  }
],



"services": [
    {
      "name": "Urbania on Rent in Daund",
      "description": "Urbania on Rent in Daund provides fully air-conditioned Urbania vehicles for city travel, family outings, corporate trips, and leisure journeys. Well-maintained vehicles with professional chauffeurs ensure a smooth, safe, and reliable travel experience."
    },
    {
      "name": "Daund Urbania Bus Hire",
      "description": "Daund Urbania Bus Hire offers spacious, fully air-conditioned buses for group travel, corporate tours, and social events. Comfort, punctuality, and safety are prioritized to ensure an enjoyable and hassle-free journey."
    },
    {
      "name": "Urbania Rental Service Daund Pune",
      "description": "Urbania Rental Service Daund Pune delivers premium Urbania vehicles suitable for family trips, corporate travel, sightseeing, and leisure outings. Experienced chauffeurs provide convenient, safe, and reliable travel at all times."
    },
    {
      "name": "Urbania AC Bus on Rent Daund",
      "description": "Urbania AC Bus on Rent Daund provides fully air-conditioned buses for long-distance travel, group tours, and corporate events. Spacious seating and trained chauffeurs ensure comfort, safety, and a stress-free journey."
    },
    {
      "name": "Corporate Urbania Hire Daund",
      "description": "Corporate Urbania Hire Daund offers reliable transportation solutions for office trips, employee commutes, and corporate events. Professional chauffeurs and punctual service ensure smooth, professional, and hassle-free travel for businesses."
    },
    {
      "name": "Urbania for Outstation Daund Pune",
      "description": "Urbania for Outstation Daund Pune ensures safe and comfortable long-distance travel with well-maintained, air-conditioned vehicles. Experienced drivers guarantee a smooth ride to nearby cities, tourist destinations, and corporate locations."
    },
    {
      "name": "Urbania Airport Transfer Daund",
      "description": "Urbania Airport Transfer Daund provides timely and hassle-free airport pickups and drops. Spacious vehicles with professional chauffeurs ensure a convenient, safe, and comfortable travel experience to and from the airport."
    },
    {
      "name": "Luxury Urbania Daund",
      "description": "Luxury Urbania Daund offers high-end, fully air-conditioned Urbania vehicles with plush interiors for VIP travel, weddings, and executive trips. Chauffeurs provide premium travel experience with comfort, style, and safety."
    },
    {
      "name": "Affordable Urbania Hire Daund",
      "description": "Affordable Urbania Hire Daund delivers cost-effective Urbania rental services without compromising on comfort or quality. Ideal for families, groups, and corporate clients seeking value-for-money transportation."
    },
    {
      "name": "Chauffeur Driven Urbania Daund",
      "description": "Chauffeur Driven Urbania Daund provides stress-free travel with trained, verified chauffeurs. Fully air-conditioned vehicles and courteous service ensure smooth, safe, and enjoyable journeys."
    },
    {
      "name": "Urbania for Wedding Events Daund",
      "description": "Urbania for Wedding Events Daund offers elegant and comfortable air-conditioned vehicles for weddings, guests, and family members. Professional chauffeurs ensure stylish, punctual, and hassle-free wedding transportation."
    },
    {
      "name": "Urbania for Office Trips Daund",
      "description": "Urbania for Office Trips Daund delivers dependable and comfortable transportation for daily office commutes, team outings, and corporate events. Focused on punctuality and convenience, it ensures smooth travel for employees and teams."
    },
    {
      "name": "Best Urbania Rental Daund Pune",
      "description": "Best Urbania Rental Daund Pune provides top-rated Urbania rental services known for reliability, vehicle quality, and customer satisfaction. Ideal for corporate travel, family trips, and group outings requiring premium and hassle-free transportation."
    },
    {
      "name": "Urbania Group Travel Daund",
      "description": "Urbania Group Travel Daund offers organized and comfortable transportation for group tours, corporate outings, and social events. Fully air-conditioned buses with professional chauffeurs ensure a safe, convenient, and enjoyable group travel experience."
    },
    {
      "name": "Reliable Urbania Hire Daund Pune",
      "description": "Reliable Urbania Hire Daund Pune ensures trustworthy, punctual, and safe Urbania rental services. Air-conditioned vehicles with trained chauffeurs provide convenient, comfortable, and reliable travel experiences for all passengers."
    }
  ],
  "tableData": [
    ["Urbania on Rent in Daund", "Daund Urbania Bus Hire"],
    ["Urbania Rental Service Daund Pune", "Urbania AC Bus on Rent Daund"],
    ["Corporate Urbania Hire Daund", "Urbania for Outstation Daund Pune"],
    ["Urbania Airport Transfer Daund", "Luxury Urbania Daund"],
    ["Affordable Urbania Hire Daund", "Chauffeur Driven Urbania Daund"],
    ["Urbania for Wedding Events Daund", "Urbania for Office Trips Daund"],
    ["Best Urbania Rental Daund Pune", "Urbania Group Travel Daund"],
    ["Reliable Urbania Hire Daund Pune", ""]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania On Rent in Daund",
        "WhyChoosedescription": "Urbania On Rent in Daund is ideal for group travel, corporate trips, family outings, wedding guest transport, and outstation journeys, offering comfort and spacious seating."
    },
    {
        "WhyChooseheading": "Luxury and Spacious Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania On Rent in Daund provides well-maintained Force Urbania vehicles with modern interiors, air-conditioning, and ample legroom for a smooth and comfortable travel experience."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Urbania On Rent in Daund comes with skilled and courteous drivers familiar with Daund routes, Pune highways, and nearby regions, ensuring safe and punctual travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Choose Urbania On Rent in Daund for competitive rates with no hidden charges, making group, corporate, and family travel budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania On Rent in Daund provides round-the-clock booking assistance and support for inquiries, reservations, and last-minute travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania On Rent in Daund is available for hourly rentals, full-day bookings, corporate trips, wedding transportation, airport transfers, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles provided for Urbania On Rent in Daund are regularly cleaned, sanitized, and serviced to ensure passenger safety and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania On Rent in Daund guarantees on-time pickups and dependable service for stress-free travel experiences."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania On Rent in Daund available for local and outstation travel?',
        answer: 'Yes, Urbania On Rent in Daund can be booked for city travel, corporate trips, family outings, and long-distance journeys.',
    },
    {
        question: 'How can I book Urbania On Rent in Daund?',
        answer: 'You can book Urbania On Rent in Daund via phone, WhatsApp, or online for fast and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania On Rent in Daund?',
        answer: 'Urbania On Rent in Daund offers spacious seating, professional drivers, clean vehicles, and transparent pricing for corporate, family, and group travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers for Urbania On Rent in Daund are trained, licensed, and experienced in providing safe and comfortable travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Urbania On Rent in Daund allows flexible pickup and drop locations across Daund, Pune, and nearby areas.',
    },
    {
        question: 'Is Urbania On Rent in Daund available 24x7?',
        answer: 'Yes, Urbania On Rent in Daund operates 24x7 to meet your travel needs anytime.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all Urbania vehicles are regularly cleaned, sanitized, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Urbania On Rent in Daund accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during trips?',
        answer: 'Yes, dedicated customer support is available throughout your journey for smooth and stress-free travel.',
    },
    {
        question: 'Can Urbania be used for corporate, family, and outstation trips?',
        answer: 'Yes, Urbania On Rent in Daund is ideal for corporate travel, family outings, airport transfers, and group or outstation journeys.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Santosh Patil',
        feedback: 'Urbania On Rent in Daund made our family trip very comfortable and enjoyable. Spacious, clean, and reliable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Seema More',
        feedback: 'We hired Urbania On Rent in Daund for a corporate outing. Excellent service and professional driver.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Rohit Jadhav',
        feedback: 'Urbania On Rent in Daund provided smooth and hassle-free travel for our group trip. Highly recommended.',
        rating: 5,
    },
];



















































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Daund",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-daund.jpg",
  "description": "Urbania On Rent in Daund offers AC and non-AC Urbania buses for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. Chauffeur-driven buses ensure safe, comfortable, and convenient transportation in Daund and surrounding areas.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2200",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-on-rent-daund"
  }
};





    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania On Rent in Daund | AC & Luxury Urbania Bus Hire 
  </title>

  <meta
    name="description"
    content="Book Urbania On Rent in Daund for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. AC and non-AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and convenient transportation in Daund Pune."
  />

  <meta
    name="keywords"
    content="Urbania on Rent in Daund, Daund Urbania Bus Hire, Urbania Rental Service Daund Pune, Urbania AC Bus on Rent Daund, Corporate Urbania Hire Daund, Urbania for Outstation Daund Pune, Urbania Airport Transfer Daund, Luxury Urbania Daund, Affordable Urbania Hire Daund, Chauffeur Driven Urbania Daund, Urbania for Wedding Events Daund, Urbania for Office Trips Daund, Best Urbania Rental Daund Pune, Urbania Group Travel Daund, Reliable Urbania Hire Daund Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/99.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentindaund;